/**
 * MediaViewerOverlay React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import Button from "@material-ui/core/Button";
import connect from "react-redux/es/connect/connect";
import {closeMediaOverlay} from '../../operations/view';
import Grow from '@material-ui/core/Grow';
import MediaPanel from "./MediaPanel";


/**
 * MediaViewerOverlay shows a media file nearly fullscreen
 *
 * @author Maurizio Tidei
 */
export class MediaViewerOverlay extends React.Component {

    render() {

        const {classes} = this.props;

        return (
            <Grow in={this.props.visible} timeout={150} unmountOnExit>
                <div className={classes.root}>
                        <div className={classes.centerHorizontally}>
                            <div className={classes.centerVertically}>
                                <MediaPanel showControls={true} title={this.props.description} url={this.props.mediaurl} otherFilesAsDownload={true}/>
                                    {
                                        // render description, but only if it is not a web address
                                        !this.props.description.startsWith("http") && !this.props.description.startsWith("/uploads") ? <p className="overlay-description">{this.props.description}</p> : ""
                                    }
                                    </div>
                                }
                        </div>
                        <Button variant="fab" mini color="primary" aria-label="Close" className={classes.button} onClick={() => {this.props.closeMediaOverlay()}}>
                          <CloseIcon />
                        </Button>
                </div>
            </Grow>);
    }
}

const styles = {
    root: {
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        alignItems: "center"
    },
    centerHorizontally: {
        display: "flex",
        position: "relative",
        margin: "0 auto",
        height: "calc(100% - 30px)",
        width: "calc(100% - 30px)",
        justifyContent: "center"

        //transition: "all 1.0s ease-in"
    },
    centerVertically: {
        justifyContent: "center",
        display: "flex",
        flexDirection: "column"
    },
    button: {
        top: "10px",
        right: "20px",
        position: "absolute"
    }
};

MediaViewerOverlay.propTypes = {
    mediaurl: PropTypes.string.isRequired,
    visible: PropTypes.bool
};

MediaViewerOverlay.defaultProps = {
    visible: true
};

export default connect((state) => {
    return {
        visible: state.view.mediaOverlayVisible,
        mediaurl: state.view.mediaOverlayUrl,
        description: state.view.mediaOverlayDescription
    }
},{closeMediaOverlay})(withStyles(styles)(MediaViewerOverlay));

